import styled from '@emotion/styled'
import { theme } from '~/utils'



export const ContainerDashboard = styled.div`
  height: 100%;
  width: 100%;

  .powerbi-content {
    height: 100%;

    iframe {
      border-radius: 12px;
      border: 1px solid ${theme.palette.divider};
      padding: 24px;
      background-color: #ffffff;
    }
    }
`
